import React from "react";
import Icon from "./Icon.jsx";

/**
 * Menu list component
 *
 * Renders a menu list item with optional icon and label.
 *
 * @param {object} props
 * @param {string} [props.id]
 *   The unique HTML element ID for the menu list.
 *
 * @param {string} [props.label]
 *   The text label to display inside the menu list item.
 * 
 * @param {string} [props.icon]
 *   Icon name to display alongside the label.
 * 
 * @param {string} [props.description]
 *  Description text to display below the label.
 * 
 * @param {function} [props.onClick]
 *   Click handler function.
 * 
 * @param {boolean} [props.disabled=false]
 *   Disables the menu list item and prevents user interaction.
 * 
 * @param {object} [props.extraAttrs]
 *   Any additional attributes forwarded to the `<button>` element.
 * 
 * @param {boolean} [props.selected=false]
 *   Marks the item as selected (adds menu-list-selected class).
 */
export default function MenuList({
    id,
    label,
    icon,
    description,
    onClick,
    disabled = false,
    selected = false,
    extraAttrs = {},
}) {

    function buildIcon(name) {
        if (!name) return null;
        return (
            <span className="menu-list-icon" data-selected={selected}>
                <Icon name={name} size="md" />
            </span>
        );
    }

    function buildDescription(text) {
        if (!text) return null;
        return (
            <span className="menu-list-description">
                {text}
            </span>
        );
    }


    return (
        <button
            id={id}
            type="button"
            className="menu-list group"
            data-selected={selected}
            aria-selected={selected}
            onClick={onClick}
            disabled={disabled}
            {...extraAttrs}
        >
            <div className="flex flex-col items-start w-full">
                <div className="flex items-center w-full">
                    {icon && buildIcon(icon)}
                    <span className="menu-list-label" data-selected={selected}>{label}</span>
                </div>
                {description && buildDescription(description)}
            </div>
        </button>
    );
}
